export const userQueryFields = `
  id
  firstName
  lastName
`;

export const pledgeCertificateCompanyRegisteredQueryFields = `
  creditor
  emitter
  volume
  pledgeArea
  matricula
  additionalInformation
`;

export const fileQueryFields = `
  id
  status
  context
  documentName
  documentType
  documentUrl
  internalStatus
  loadedAt
  uploadedBy {
    ${userQueryFields}
  }
  metadata {
    comment
    phase3FileInfo {
      pledgeCertificateRegistrationNumber
      pledgeCertificateRegistrationDate
      pledgeCertificateLevel
      pledgeCertificateFirstCompanyRegistered {
        ${pledgeCertificateCompanyRegisteredQueryFields}
      }
      pledgeCertificateSecondCompanyRegistered {
        ${pledgeCertificateCompanyRegisteredQueryFields}
      }
      isRegisteredMinutaValid
      isConsentLetterValid
      isOtherValidationValid
      isAmendmentSignedValid
    }
    salesforceContentVersionModifiedByName
  }
`;

export const stateQueryFields = `
  id
  name
`;

export const municipalityQueryFields = `
  id
  name
`;
